/**
 * WordPress Data Store for TopBuddy
 * 
 * Manages shared state between metabox and preview
 * 
 * @package TopBuddy
 */

import { createReduxStore, register } from '@wordpress/data';
import './settingsStore';
import './uiStore';
import './displayRulesStore';

const STORE_NAME = 'topbuddy/components';

const DEFAULT_STATE = {
	activeComponents: [],
	availableComponents: {},
};

const actions = {
	setActiveComponents(components) {
		return {
			type: 'SET_ACTIVE_COMPONENTS',
			components,
		};
	},
	setAvailableComponents(components) {
		return {
			type: 'SET_AVAILABLE_COMPONENTS',
			components,
		};
	},
};

const reducer = (state = DEFAULT_STATE, action) => {
	switch (action.type) {
		case 'SET_ACTIVE_COMPONENTS':
			return {
				...state,
				activeComponents: action.components,
			};
		case 'SET_AVAILABLE_COMPONENTS':
			return {
				...state,
				availableComponents: action.components,
			};
		default:
			return state;
	}
};

const selectors = {
	getActiveComponents(state) {
		return state.activeComponents;
	},
	getAvailableComponents(state) {
		return state.availableComponents;
	},
	getComponentConfig: (state) => (componentId) => {
		return state.availableComponents[componentId] || null;
	},
};

const store = createReduxStore(STORE_NAME, {
	reducer,
	actions,
	selectors,
});

// Only register if not already registered
if (!window.wp.data.select(STORE_NAME)) {
	register(store);
}

export default store;
